<div
  class="flex items-center justify-center mt-24 text-center space-y-4"
>
  <div class="flex flex-col items-center space-y-4">
    <img
      src="assets/images/no_results.png"
      alt="No Results Found"
      class="w-48 h-auto"
    />
    <p class="text-lg text-gray-500">{{ message }}</p>
  </div>
</div>
